import React from "react";

export default function BridgeStartReverse() {
  return (
    <img
      src="/assets/odontogram/bridge-start.svg"
      alt="brigde-start"
      style={{
        WebkitTransform: "scaleY(-1)",
        transform: "scaleY(-1)",
      }}
    ></img>
  );
}
